export default function RelativeRiskDetailsController(
  $rootScope,
  $scope,
  $q,
  $timeout,
  alerts
) {
  const vm = this;

  vm.handleProcessRiskInputBlur = _handleProcessRiskInputBlur;
  vm.handleMaximumAcceptableDowntimeChange = _handleMaximumAcceptableDowntimeChange;
  vm.handleCheckRecoveryTimeObjective = _handleCheckRecoveryTimeObjective;
  vm.handleRecoveryTimeObjectiveChange = _handleRecoveryTimeObjectiveChange;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _setMaxMadValues();
    $scope.$on(
      'setMaxMadValues',
      _setMaxMadValues
    );
  }

  function _handleProcessRiskInputBlur(processRisk, riskCategory, oldRiskScore, newRiskScore) {
    if (oldRiskScore !== newRiskScore) {
      let newMad;
      const blurredRiskTableRowIndex = vm.process.assessmentProcessRisks.indexOf(processRisk);

      angular.forEach(
        vm.process.assessmentProcessRisks,
        (currentRiskTableRow, currentRiskTableRowIndex) => {
          _adjustRiskTableCategoryValues(
            riskCategory,
            currentRiskTableRow,
            currentRiskTableRowIndex,
            blurredRiskTableRowIndex,
            newRiskScore
          );

          newMad = _checkRiskScoresForNewMad(newMad, currentRiskTableRow);
        }
      );

      if (newMad && vm.process.maximumAcceptableDowntime > newMad) {
        vm.process.maximumAcceptableDowntime = _checkAllowableMaximumAcceptableDowntime(newMad);
      }
      vm.process.allowableMaximumAcceptableDowntime = _checkAllowableMaximumAcceptableDowntime(newMad);


      _checkRtoLessThanMad();
      _triggerGraphReRender();

      $timeout(
        _checkReadyToSubmit,
        0
      );
    }
  }

  function _adjustRiskTableCategoryValues(
    riskCategory,
    riskTableRowToCheck,
    riskTableRowToCheckIndex,
    changedRiskTableRowIndex,
    newRiskScore
  ) {
    // Set all rows above selected row to have a value no greater than the selected row, if applicable
    const currentRowSelectedCategoryRiskScore = riskTableRowToCheck[`${riskCategory}RiskValue`];
    if (
      riskTableRowToCheckIndex < changedRiskTableRowIndex
      && currentRowSelectedCategoryRiskScore > newRiskScore
    ) {
      riskTableRowToCheck[`${riskCategory}RiskValue`] = newRiskScore;
    }

    // Set all rows below selected row to have a value no less than the selected row, if applicable
    if (
      riskTableRowToCheckIndex > changedRiskTableRowIndex
      && currentRowSelectedCategoryRiskScore < newRiskScore
    ) {
      riskTableRowToCheck[`${riskCategory}RiskValue`] = newRiskScore;
    }
  }

  function _checkRiskScoresForNewMad(newMad, currentRiskTableRow) {
    if (
      !newMad
      && (
        currentRiskTableRow.operationalRiskValue === 10
        || currentRiskTableRow.regulatoryRiskValue === 10
        || currentRiskTableRow.strategicRiskValue === 10
        || currentRiskTableRow.reputationalRiskValue === 10
      )
    ) {
      return currentRiskTableRow.recoveryTimeOptionId === 1
        ? 0.5
        : currentRiskTableRow.recoveryTimeOptionId - 1;
    }
    return newMad;
  }

  function _checkAllowableMaximumAcceptableDowntime(newMad) {
    if (newMad && newMad <= 10) {
      return newMad;
    }
    // Current Risk Score doesn't reach 10, default the input to max 30 days
    return 30;
  }

  function _setMaxMadValues() {
    let newAllowableMad;
    angular.forEach(
      vm.process.assessmentProcessRisks,
      (currentProcessRisk) => {
        newAllowableMad = _checkRiskScoresForNewMad(newAllowableMad, currentProcessRisk);
      }
    );

    if (newAllowableMad && vm.process.maximumAcceptableDowntime > newAllowableMad) {
      vm.process.maximumAcceptableDowntime = _checkAllowableMaximumAcceptableDowntime(newAllowableMad);
    }
    vm.process.allowableMaximumAcceptableDowntime = _checkAllowableMaximumAcceptableDowntime(newAllowableMad);
  }

  function _checkRtoLessThanMad() {
    const mad = vm.process.maximumAcceptableDowntime;
    if (vm.process.recoveryTimeObjective >= mad) {
      // eslint-disable-next-line max-len
      vm.process.recoveryTimeObjective = mad > 0.5 ? mad - 0.5 : 0;
    }
  }

  function _triggerGraphReRender() {
    $timeout(
      () => {
        $rootScope.$broadcast(
          'reRenderImpactAnalysisGraph',
          {
            processId: vm.process.processId,
          }
        );
      },
      20
    );
  }

  function _checkReadyToSubmit() {
    $timeout(
      () => {
        if ($scope.relativeRiskForm.$$parentForm.$invalid) {
          vm.process.readyToSubmit = false;
        }
      },
      0
    );
  }

  function _handleMaximumAcceptableDowntimeChange() {
    _checkRtoLessThanMad();
    _triggerGraphReRender();
    _checkReadyToSubmit();
  }

  function _handleCheckRecoveryTimeObjective() {
    if (!vm.process.maximumAcceptableDowntime) {
      alerts.error(
        'A Maximum Acceptable Downtime must be set before the Recovery Time Objective can be set. '
        + 'Please fill out the risk table above to determine the Maximum Acceptable Downtime.'
      );
    }
  }

  function _handleRecoveryTimeObjectiveChange(oldValue) {
    if (vm.process.recoveryTimeObjective < 0) {
      vm.process.recoveryTimeObjective = 0;
    }
    if (vm.process.recoveryTimeObjective > vm.process.maximumAcceptableDowntime) {
      vm.process.recoveryTimeObjective = oldValue;
      alerts.error('The Recovery Time Objective can\'t exceed the Maximum Acceptable Downtime.');
    }
    _triggerGraphReRender();
    _checkReadyToSubmit();
  }
}

RelativeRiskDetailsController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$timeout',
  'alerts'
];
